module.exports = fox._r("fonts/mc-admin-common.woff", __webpack_public_path__ + "_/_/_/common/frame/fonts/3FZHPLv.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/fonts/mc-admin-common.woff
// module id = 114
// module chunks = 2